import { Timeline } from '@design-systems/canvas-ui'
import {
  STATUS_INITIATED,
  STATUS_REJECTED,
  STATUS_SENT_BACK,
  STATUS_STARTED,
} from './commonConstants'

export const CustomTimelineItem = (props) => {
  const getVariant = () => {
    switch (props.vetting_status?.toLowerCase()) {
      case STATUS_SENT_BACK.toLowerCase():
        return 'caution'
      case STATUS_INITIATED.toLowerCase():
        return 'info'
      case STATUS_STARTED.toLowerCase():
        return 'info'
      case STATUS_REJECTED.toLowerCase():
        return 'error'
      default:
        return 'success'
    }
  }

  return (
    <Timeline.Item
      data-testid="timeline-item"
      variant={getVariant()}
      className="hc8-mt-none hc8-mb-2x"
    >
      {props.component}
    </Timeline.Item>
  )
}
